// extracted by mini-css-extract-plugin
export default {"header":"Modals_header__kEpJw","modalIcon":"Modals_modalIcon__sHJ-3","edittableContainer":"Modals_edittableContainer__rO9f7"};